var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5401",
    "data-name": "Group 5401",
    transform: "translate(0 0.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_364",
    "data-name": "Ellipse 364",
    transform: "translate(0 -0.237)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9063",
    "data-name": "Path 9063",
    d: "M8.071-23.064h6.248a8.824,8.824,0,0,1,3.934.656,3.307,3.307,0,0,1,1.658,1.967,11.747,11.747,0,0,1,.424,3.509,12.856,12.856,0,0,1-.386,3.509,3,3,0,0,1-1.311,1.851,8.985,8.985,0,0,1-3.934.694H8.071V-4.63A8.824,8.824,0,0,1,7.416-.7,3.307,3.307,0,0,1,5.449.963a11.747,11.747,0,0,1-3.509.424A11.747,11.747,0,0,1-1.57.963,3.048,3.048,0,0,1-3.421-.464a10.224,10.224,0,0,1-.694-4.242v-6.171h-6.71a8.287,8.287,0,0,1-3.7-.617,3.081,3.081,0,0,1-1.543-1.967,13.116,13.116,0,0,1-.386-3.51,11.984,11.984,0,0,1,.424-3.509,2.988,2.988,0,0,1,1.5-1.89,10.224,10.224,0,0,1,4.242-.694h6.171v-6.248A9.312,9.312,0,0,1-3.5-33.245,3.168,3.168,0,0,1-1.531-34.9a11.983,11.983,0,0,1,3.509-.424,11.983,11.983,0,0,1,3.509.424,3.06,3.06,0,0,1,1.89,1.427,10.224,10.224,0,0,1,.694,4.242Z",
    transform: "translate(42.977 61.97)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlus);
export default __webpack_public_path__ + "static/media/btn_plus.945c32d8.svg";
export { ForwardRef as ReactComponent };